module.exports = __webpack_public_path__ + "static/media/20-1.a1e0b799.jpg";